<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title class="text-uppercase">{{ dialogTitle }}</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="closeDialog">close</v-icon>
      </v-card-title>
      <v-card-text class="pt-6">
        <v-form ref="form">
          <h3 class="mb-2">1. Thông tin cơ bản</h3>
          <v-text-field
            v-model="title"
            :rules="[$rules.required]"
            label="Tiêu đề"
            placeholder="Nhập tiêu đề"
            outlined
            dense
          />
          <v-text-field
            v-model="location"
            :rules="[$rules.required]"
            label="Địa điểm"
            placeholder="Nhập địa điểm"
            outlined
            dense
          />
          <v-text-field
            v-model="quantity"
            :rules="[$rules.required, $rules.isNumber]"
            label="Số lớp (nhập số)"
            placeholder="Nhập số lớp"
            outlined
            dense
          />
          <h3 class="mb-2">2. Thời gian diễn ra</h3>
          <v-text-field
            v-model="date"
            :rules="[$rules.required]"
            label="Ngày diễn ra"
            placeholder="Nhập ngày diễn ra"
            outlined
            dense
          />
          <h3 class="mb-2">3. Giới hạn đăng ký</h3>
          <v-text-field
            v-model="attendLimit"
            :rules="[$rules.required, $rules.isNumber]"
            label="Giới hạn đăng ký (nhập số)"
            placeholder="Nhập giới hạn đăng ký"
            outlined
            dense
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn width="97px" outlined class="ma-2" @click="closeDialog">Hủy</v-btn>
        <v-spacer />
        <v-btn depressed color="primary" class="ma-2 white--text" @click="onSave">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data: () => ({
    dialog: false,
    title: '',
    location: '',
    date: '',
    quantity: null,
    attendLimit: null,
    type: 'create',
    id: ''
  }),
  computed: {
    ...mapGetters({
      event: 'events/getItem'
    }),
    dialogTitle() {
      return this.type === 'create' ? 'Tạo lớp' : 'Sửa lớp'
    }
  },
  methods: {
    ...mapActions({
      createEventSlot: 'eventSlots/create',
      updateEventSlot: 'eventSlots/update'
    }),
    init(item = {}) {
      const { title, location, date, quantity, attendLimit, id } = item
      this.title = title
      this.location = location
      this.date = date
      this.quantity = quantity
      this.attendLimit = attendLimit
      this.id = id
    },
    openDialog(type = '', item) {
      this.type = type
      if (item) this.init(item)
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onSave() {
      const isValid = this.$refs.form.validate()
      if (!isValid) return this.$alert.error('Vui lòng kiểm tra các trường thông tin bắt buộc')
      try {
        this.$loading.active = true

        const params = {
          title: this.title,
          location: this.location,
          date: this.date,
          quantity: Number(this.quantity),
          attendLimit: Number(this.attendLimit)
        }
        if (this.type === 'create') await this.createEventSlot({ event: this.event.id, ...params })
        else await this.updateEventSlot({ id: this.id, ...params })

        this.$alert.success(`${this.dialogTitle} thành công`)
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
